// import jQuery from 'jquery';
import './style.scss';

import LazyLoad from './lazyLoad/lazyLoad';
import Subpage from '../src/Layout/Subpage';

// Components
import CarsCarusel from '../src/Components/CarsCarusel/CarsCarusel';
import CarGallery from '../src/Components/CarGallery/CarGallery';
import ContactForm from '../src/Components/ContactForm/ContactForm';
import SliderImages from '../src/Components/SliderImages/SliderImages';
import GoogleMap from '../src/Components/GoogleMap/GoogleMap';
import Cookie from '../src/Components/Cookie/Cookie';
import LightList from '../src/Components/LightList/LightList';
import RelatedProductSlick from '../src/Components/RelatedProductSlick/RelatedProductSlick';

// Sections
import FullscreenSlider from '../src/Sections/FullscreenSlider/FullscreenSlider';
import RentalCar from '../src/Sections/RentalCar/RentalCar';
import SliderImagesTouch from '../src/Sections/SliderImagesTouch/SliderImagesTouch';
import SectionAbout from '../src/Sections/About/About';
import FullscreenImage from '../src/Sections/FullscreenImage/FullscreenImage';
import HolidayBar from '../src/Sections/HolidayBar/HolidayBar';
import ShopAdvertisement from '../src/Sections/ShopAdvertisement/ShopAdvertisement';

// pages
import ArchiveTrade from '../src/Pages/ArchiveTrade/ArchiveTrade';
import Fleet from '../src/Pages/Fleet/Fleet';
import About from '../src/Pages/About/About';
import DefaultTemplate from '../src/Pages/DefaultTemplate/DefaultTemplate';

// WooCommerce
import ProductList from '../src/Shop/ProductList/ProductList';
import SingleProduct from '../src/Shop/SingleProduct/SingleProduct';
import AfterOrderNotes from '../src/Shop/Checkout/AfterOrderNotes/AfterOrderNotes';
import AfterPayment from '../src/Shop/Checkout/AfterPayment/AfterPayment';

LazyLoad.init();

document.addEventListener("DOMContentLoaded", function() {
    
    Subpage.init();

    // components
    Cookie.init();
    CarsCarusel.init();
    CarGallery.init();
    ContactForm.init();
    SliderImages.init();
    GoogleMap.init();
    LightList.init();
    RelatedProductSlick.init();

    //sections
    FullscreenSlider.init();
    RentalCar.init();
    SliderImagesTouch.init();
    SectionAbout.init();
    FullscreenImage.init();
    HolidayBar.init();
    ShopAdvertisement.init();
    
    //pages
    ArchiveTrade.init();
    Fleet.init();
    About.init();
    DefaultTemplate.init();

    //Woo
    ProductList.init();
    SingleProduct.init();
    AfterOrderNotes.init();
    AfterPayment.init();
    
});
